import React from 'react';
import {
  StackLayout,
  Button,
  ParagraphText,
  ImageMessage,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import exitWarning from 'assets/exit-warning.svg';
import { BaseModalContainer } from './common/base-modal.component';

interface ModalProps {
  onClose: () => void;
  onConfirm: () => void;
}

export const UnsubscribeWarningModal: React.FC<ModalProps> = ({
  onClose,
  onConfirm,
}) => {
  const { formatMessage } = useIntl();

  return (
    <BaseModalContainer
      title={formatMessage({ id: 'STR_ARE_YOU_SURE' })}
      footer={
        <StackLayout
          orientation={{ '@initial': 'horizontal', '@mobile': 'vertical' }}
          spacing="$oneAndHalf"
          verticalAlignment="stretch"
          horizontalAlignment="stretch"
          css={{
            '> *': {
              flex: '1',
              justifyContent: 'center',
            },
          }}
        >
          <Button
            css={{
              height: '$three',
              whiteSpace: 'nowrap',
              '&:hover, &:active, &:focus': {
                backgroundColor: '$interactiveBackgroundHovered',
                color: '$interactiveActionHovered',
                textDecoration: 'none',
              },
            }}
            onClick={onClose}
            priority="secondary"
          >
            {formatMessage({ id: 'STR_CANCEL' })}
          </Button>
          <Button
            css={{
              height: '$three',
              whiteSpace: 'nowrap',
              '&:hover, &:active, &:focus': {
                backgroundColor: '$interactiveBackgroundHovered',
                color: '$interactiveActionHovered',
                textDecoration: 'none',
              },
            }}
            onClick={onConfirm}
          >
            {formatMessage({ id: 'STR_YES_UNSUBSCRIBE' })}
          </Button>
        </StackLayout>
      }
    >
      <ImageMessage image={exitWarning}>
        <ParagraphText
          css={{ marginBottom: '$oneAndHalf', textAlign: 'center' }}
        >
          {formatMessage({ id: 'STR_UNSUBSCRIBE_MODAL_DESCRIPTION' })}
        </ParagraphText>
      </ImageMessage>
    </BaseModalContainer>
  );
};
